import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JoinService } from '../join/join.service';
import { UserDataService } from '../user-data/user-data.service';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class AuthenticationService {
    admin = false;
    ccs = false;
    loggedIn = false;
    didSetUserType = false;
    showWelcomeDeck = false;

    constructor(
        private userService: UserDataService,
        private router: Router,
        private joinService: JoinService,
        private cookieService: CookieService
    ) {}

    createAdminUrl(): string {
        let urlParams: string = "{}";
        let adminUrl = `${environment.redirectionUrl}home/search`;

        if (this.cookieService.get(environment.FILTER_COOKIE)) {
            urlParams = this.cookieService.get(environment.FILTER_COOKIE) || "{}";
            adminUrl = `${environment.redirectionUrl}home/drivers`;
        } else if (this.cookieService.get(environment.SEARCH_PAGE_COOKIE)) {
            urlParams = this.cookieService.get(environment.SEARCH_PAGE_COOKIE) || "{}";
            adminUrl = `${environment.redirectionUrl}home/search`;
        }
        
        if (urlParams) {
            urlParams = JSON.parse(urlParams);
            let initialValue = '';
            let keys = Object.keys(urlParams).filter((key) => key !== 'token');
            let viewUrl = keys.reduce((url, key) => {
                url = url ? `${url}&` : `${url}?`;
                return url + key + '=' + encodeURIComponent(urlParams[key]);
            }, initialValue);
            return `${adminUrl}${viewUrl}`;
        } else {
            return adminUrl;
        }
    }

    getToken(): string | null {
        let token = localStorage.getItem('driverAuthToken'),
            user: any = localStorage.getItem('userData');
        if (!token && localStorage.getItem('userData')) {
            token = JSON.parse(user).token;
        }
        return token;
    }

    isAdmin(): boolean {
        let adminCookieValue: any = this.cookieService.get(
            environment.ADMIN_COOKIE
        );
        return adminCookieValue === 'yes';
    }

    isCcs(): boolean {
        let ccsCookieValue: any = this.cookieService.get(
            environment.CCS_COOKIE
        );
        return ccsCookieValue === 'yes';
    }

    isLoggedIn(): boolean {
        return this.loggedIn;
    }

    logOut(redirectionUrl: string = 'login', data: any = {}): void {
        this.loggedIn = false;
        const isAdmin = this.isAdmin();
        const backURL = this.createAdminUrl();
        const token = this.getToken();
        sessionStorage.removeItem('driverAuthToken');
        localStorage.removeItem('is_locked');
        localStorage.removeItem('displayedContactInfoPopup');
        if (token) {
            if (redirectionUrl !== 'reset') {
                this.userService.logoutDriver().subscribe((data) => {});
            }
            localStorage.removeItem('driverAuthToken');
            localStorage.removeItem('status');
            localStorage.removeItem('texted_logs');
            localStorage.removeItem('activity_level');
            localStorage.removeItem('lifetime_rides');
            if (!localStorage.getItem('isAdmin') === null) {
                localStorage.removeItem('isAdmin');
            }

            this.cookieService.delete(environment.ADMIN_COOKIE);
            this.cookieService.delete(environment.CCS_COOKIE);
            this.cookieService.delete(environment.COOKIE_NAME);
        }
        this.cookieService.delete('tablet_id');
        this.cookieService.delete('dontHaveUber');
        this.userService.setUserSummary(null);
        this.joinService.setUserData(null);

        if (isAdmin) {
            window.location.href = backURL;
        } else if (redirectionUrl === 'reset') {
            // Navigate to the resetLink URL passed in the data object
            if (data?.resetLink) {
                window.location.href = data?.resetLink;
            } else {
                this.router.navigate(['reset']);
            }
        } else {
            this.router.navigate(['login']);
        }
    }

    setToken(token: string) {
        this.loggedIn = true;
        localStorage.setItem('driverAuthToken', token);
        this.setUserType();
    }

    setUserType(): void {
        this.didSetUserType = true;
        let adminCookieValue: any = this.cookieService.get(
            environment.ADMIN_COOKIE
        );
        let ccsCookieValue: any = this.cookieService.get(
            environment.CCS_COOKIE
        );
        if (adminCookieValue === 'yes') {
            this.admin = true;
        } else {
            this.admin = false;
            this.cookieService.delete(environment.ADMIN_COOKIE);
        }
        if (ccsCookieValue === 'yes') {
            this.ccs = true;
        } else {
            this.ccs = false;
            this.cookieService.delete(environment.CCS_COOKIE);
        }
    }

    decodeToken(token: string): object {
        let base64Url = token.split('.')[1];
        let base64 = base64Url.replace('-', '+').replace('_', '/');
        let decodedJwt = JSON.parse(window.atob(base64));
        return decodedJwt;
    }

    setWelcomeDeckValue(val: boolean) {
        this.showWelcomeDeck = val;
    }

    shouldShowWelcomeDeck(): boolean {
        return this.showWelcomeDeck;
    }
}
